import { Injectable } from '@angular/core';

import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { FirebaseObjectObservable, FirebaseObjectFactory } from 'angularfire2/database';

import 'rxjs/add/operator/take';

import { Event } from '../models/event';
import { EventService } from '../services/event.service';

@Injectable()
export class EventResolverService implements Resolve<FirebaseObjectObservable<Event | null> | null> {

  constructor(
    private router: Router,
    private eventService: EventService
  ) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): FirebaseObjectObservable<FirebaseObjectObservable<Event | null> | null> {
    const id = route.paramMap.get('event_id');

    if (!id) {
      throw Error('No event_id specified.');
    }

    return this.eventService.getEvent(id)
      .take(1)
      .map((event: Event) => {
        if (event) {
          return this.eventService.getEvent(id);
        } else {
          this.router.navigateByUrl('/');
          return null;
        }
      }) as FirebaseObjectObservable<FirebaseObjectObservable<Event | null> | null>;
  }
}



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/services/event-resolver.service.ts